import { connect } from "react-redux";
import { compose, lifecycle, withState, withHandlers, branch, renderComponent } from "recompose";
import ToolkitBoard, { ToolkitBoardProps } from "./ToolkitBoard";
import { IdeasSlice } from "src/pods/ideas";
import DiscussContainer from "src/pods/ideas/components/cards/screen/DiscussContainer";
import WatchVideoContainer from "src/pods/ideas/components/cards/screen/WatchVideoContainer";
import { Board, Lesson, Slide } from "src/pods/ideas/data/types";
import { Question } from "src/pods/pairshare/types";
import { displayOpen, displayClose } from "src/pods/realtime";

function mapStateToProps(_: IdeasSlice, { board }: { board: Board }) {
  return {
    board,
  };
}

const mapDispatchToProps = {
  displayOpen,
  displayClose,
};

type Video = {
  watch: Slide;
  lesson: Lesson;
};
type Props = {
  displayOpen: typeof displayOpen;
  displayClose: typeof displayClose;
  selectQuestion: (question: Question | null) => void;
  selectVideo: (video: Video | null) => void;
  video: Video;
  question: Question;
};

export default compose<ToolkitBoardProps, ToolkitBoardProps>(
  connect(mapStateToProps, mapDispatchToProps),
  withState("question", "selectQuestion", null),
  withState("video", "selectVideo", null),
  lifecycle<Props, Props, { _lastScrollPosition?: number }>({
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps: Props) {
      const willDisplayVideo = !this.props.video && nextProps.video;
      const willDisplayQuestion = !this.props.question && nextProps.question;

      if (willDisplayVideo || willDisplayQuestion) {
        this._lastScrollPosition = window.scrollY;
      }

      if (this._lastScrollPosition) {
        window.scrollTo(0, this._lastScrollPosition);
      }
    },
  }),
  branch<any>(
    ({ question }) => question,
    renderComponent((props: Props) => (
      <DiscussContainer
        displayOpen={props.displayOpen}
        displayClose={props.displayClose}
        onBack={() => props.selectQuestion(null)}
        question={props.question}
      />
    )),
  ),
  branch<any>(
    ({ video }) => video,
    renderComponent((props: Props) => (
      <WatchVideoContainer
        displayOpen={props.displayOpen}
        displayClose={props.displayClose}
        onBack={() => props.selectVideo(null)}
        watch={props.video.watch}
        lesson={props.video.lesson}
      />
    )),
  ),
  withHandlers<any, any>({
    displayDiscussCard:
      ({ selectQuestion }) =>
      (question: Question) => {
        selectQuestion(question);
      },
    displayVideoCard:
      ({ selectVideo }) =>
      (watch: Slide, lesson: Lesson) =>
        selectVideo({
          watch,
          lesson,
        }),
  }),
)(ToolkitBoard);
